window.setTimeout(function() {
    'use strict';
        
    let LOGGING_ENABLED = false;
    
    function log(...args) {
        if (LOGGING_ENABLED) {
            log(...args);
        }
    }
    
    function warn(...args) {
        if (LOGGING_ENABLED) {
            warn(...args);
        }
    }
    
    function error(...args) {
        if (LOGGING_ENABLED) {
            error(...args);
        }
    }
    
    function setLogging(enabled) {
        LOGGING_ENABLED = enabled;
        log(`🔧 Логирование ${enabled ? 'включено' : 'отключено'}`);
    }
    
    function isLoggingEnabled() {
        return LOGGING_ENABLED;
    }
    
    function transformProductCard(element) {
        // Извлекаем данные из исходного элемента
        const linkElement = element.querySelector('.grid-product__link');
        const imageElement = element.querySelector('img');
        const titleElement = element.querySelector('.grid-product__title');
        const textElement = element.querySelector('.grid-product__text');
        
        // Получаем необходимые данные
        const productUrl = linkElement ? linkElement.getAttribute('href') : '#';
        const imageSrc = imageElement ? imageElement.getAttribute('src') : '';
        const imageAlt = imageElement ? imageElement.getAttribute('alt') : '';
        const imageSrcset = imageElement ? imageElement.getAttribute('srcset') : '';
        const imageWidth = imageElement ? imageElement.getAttribute('width') : '';
        const imageHeight = imageElement ? imageElement.getAttribute('height') : '';
        const productTitle = titleElement ? titleElement.textContent.trim() : '';
        
        // Создаем новую структуру
        const newElement = document.createElement('div');
        newElement.className = 'product-card text-center';
        
        // Создаем ссылку с изображением
        const link = document.createElement('a');
        link.href = productUrl;
        link.className = 'product-card__image rte__image';
        
        // Создаем изображение
        const img = document.createElement('img');
        img.src = imageSrc;
        img.alt = imageAlt;
        if (imageSrcset) img.srcset = imageSrcset;
        if (imageWidth) img.width = imageWidth;
        if (imageHeight) img.height = imageHeight;
        
        // Создаем hover эффект с иконкой корзины
        const hoverSpan = document.createElement('span');
        hoverSpan.className = 'product-card-hover';
        
        const cartIcon = document.createElement('svg');
        cartIcon.setAttribute('width', '24');
        cartIcon.setAttribute('height', '24');
        cartIcon.className = 'header-icon';
        
        const useElement = document.createElement('use');
        useElement.setAttribute('xlink:href', '#cart-icon-svg');
        cartIcon.appendChild(useElement);
        hoverSpan.appendChild(cartIcon);
        
        // Добавляем изображение и hover эффект к ссылке
        link.appendChild(img);
        link.appendChild(hoverSpan);
        
        // Создаем заголовок
        const h3 = document.createElement('h3');
        const titleLink = document.createElement('a');
        titleLink.href = productUrl;
        titleLink.textContent = productTitle;
        h3.appendChild(titleLink);
        
        // Собираем финальную структуру
        newElement.appendChild(link);
        newElement.appendChild(h3);
        
        return newElement;
    }
    
    function getTextLength(element) {
        if (!element) return 0;
        return element.innerText ? element.innerText.length : 0;
    }
    
    /**
     * Функция для поиска элемента по уникальному классу
     * 
     * @param {string} className - Уникальный класс для поиска
     * @returns {HTMLElement|null} - Найденный элемент или null
     */
    function findElementByClass(className) {
        const elements = document.querySelectorAll(`.${className}`);
        
        if (elements.length === 0) {
            return null;
        }
        
        if (elements.length > 1) {
            warn(`⚠️  Найдено ${elements.length} элементов с классом "${className}". Будет использован первый.`);
        }
        
        return elements[0];
    }
    
    /**
     * Функция для получения соседних элементов определенных типов
     * Ищем соседние элементы родительского элемента опорного элемента
     */
    function getSiblingElements(parentElement, referenceElement, debug = false) {
        if (!parentElement || !referenceElement) return [];
        
        const allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'ul', 'ol'];
        const siblings = [];
        
        
        // Получаем родительский элемент родительского элемента (дедушка)
        const grandParentElement = parentElement.parentElement;
        
        if (!grandParentElement) {
            if (debug) {
                log('   ❌ Родительский элемент родительского элемента не найден!');
            }
            return [];
        }
        
        if (debug) {
            log('   Дедушка (родитель родителя):', grandParentElement);
        }
        
        // Получаем все дочерние элементы дедушки
        const children = Array.from(grandParentElement.children);
        
        if (debug) {
            log('   Всего дочерних элементов у дедушки:', children.length);
            log('   Дочерние элементы дедушки:', children.map((el, i) => `${i}: ${el.tagName.toLowerCase()} (${el.className || 'no-class'})`));
        }
        
        // Находим индекс родительского элемента среди детей дедушки
        const parentIndex = children.indexOf(parentElement);
        
        if (debug) {
            log('   Индекс родительского элемента:', parentIndex);
        }
        
        if (parentIndex === -1) {
            if (debug) {
                log('   ❌ Родительский элемент не найден среди дочерних элементов дедушки!');
            }
            return [];
        }
        
        // Собираем элементы после родительского элемента
        if (debug) {
            log('   Поиск элементов после родительского элемента (индекс', parentIndex + 1, 'до', children.length, ')');
        }
        
        for (let i = parentIndex + 1; i < children.length; i++) {
            const child = children[i];
            const tagName = child.tagName.toLowerCase();
            const isAllowed = allowedTags.includes(tagName);
            
            if (debug) {
                log(`   Элемент ${i}: ${tagName} (${child.className || 'no-class'}) - ${isAllowed ? '✅ разрешен' : '❌ не разрешен'}`);
            }
            
            if (isAllowed) {
                siblings.push(child);
                if (debug) {
                    log(`   ✅ Добавлен в список соседних элементов`);
                }
            }
        }
        
        if (debug) {
            log('   Итого найдено соседних элементов:', siblings.length);
            log('   Соседние элементы:', siblings.map(el => `${el.tagName.toLowerCase()} (${el.className || 'no-class'})`));
        }
        
        return siblings;
    }
    
    /**
     * Функция для отбора элементов до достижения порога символов
     */
    function selectElementsByCharacterThreshold(elements, threshold = 500) {
        const selectedElements = [];
        let totalCharacters = 0;
        
        for (const element of elements) {
            const elementLength = getTextLength(element);
            
            // Если добавление этого элемента превысит порог, останавливаемся
            if (totalCharacters + elementLength > threshold) {
                break;
            }
            
            selectedElements.push(element);
            totalCharacters += elementLength;
        }
        
        return selectedElements;
    }
    
    /**
     * Функция для создания новой структуры column-row
     */
    function createColumnRowStructure(leftElements, rightElement) {
        const columnRow = document.createElement('div');
        columnRow.className = 'column-row product_row';
        
        // Создаем левую часть
        const leftDiv = document.createElement('div');
        leftDiv.className = 'left';
        
        // Добавляем отобранные элементы в левую часть
        leftElements.forEach(element => {
            leftDiv.appendChild(element.cloneNode(true));
        });
        
        // Создаем правую часть
        const rightDiv = document.createElement('div');
        rightDiv.className = 'right';
        
        // Добавляем преобразованный элемент в правую часть
        if (rightElement) {
            rightDiv.appendChild(rightElement);
        }
        
        // Собираем структуру
        columnRow.appendChild(leftDiv);
        columnRow.appendChild(rightDiv);
        
        return columnRow;
    }
    
    /**
     * Функция для замены группы элементов на новую структуру
     * Заменяем родительский элемент опорного элемента вместе с соседними элементами
     */
    function replaceElementsWithNewStructure(parentElement, referenceElement, selectedElements, newStructure, debug = false) {
        if (!parentElement || !referenceElement || !newStructure) return;
        
        if (debug) {
            log('🔄 ДЕБАГ replaceElementsWithNewStructure:');
            log('   Родительский элемент:', parentElement);
            log('   Опорный элемент:', referenceElement);
            log('   Отобранные элементы:', selectedElements);
            log('   Новая структура:', newStructure);
        }
        
        // Получаем дедушку (родитель родителя)
        const grandParentElement = parentElement.parentElement;
        if (!grandParentElement) {
            if (debug) {
                log('   ❌ Дедушка не найден');
            }
            return;
        }
        
        if (debug) {
            log('   Дедушка:', grandParentElement);
        }
        
        // Находим индекс родительского элемента среди детей дедушки
        const children = Array.from(grandParentElement.children);
        const parentIndex = children.indexOf(parentElement);
        
        if (debug) {
            log('   Индекс родительского элемента:', parentIndex);
            log('   Всего детей у дедушки:', children.length);
        }
        
        if (parentIndex === -1) {
            error('❌ Родительский элемент не найден среди детей дедушки');
            return;
        }
        
        // Находим все элементы, которые нужно удалить
        // Удаляем родительский элемент опорного элемента и все соседние элементы
        const elementsToRemove = [parentElement, ...selectedElements];
        
        if (debug) {
            log('   Элементы для удаления:', elementsToRemove.map(el => `${el.tagName.toLowerCase()} (${el.className || 'no-class'})`));
        }
        
        // Удаляем элементы из DOM
        elementsToRemove.forEach(element => {
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        });
        
        // Находим элемент, который должен идти после новой структуры
        // Это будет первый элемент после удаленных элементов
        const remainingChildren = Array.from(grandParentElement.children);
        const insertBeforeElement = remainingChildren[parentIndex] || null;
        
        if (debug) {
            log('   Оставшиеся дети после удаления:', remainingChildren.length);
            log('   Элемент для вставки перед:', insertBeforeElement ? `${insertBeforeElement.tagName.toLowerCase()} (${insertBeforeElement.className || 'no-class'})` : 'null');
        }
        
        // Вставляем новую структуру на место родительского элемента
        if (insertBeforeElement) {
            grandParentElement.insertBefore(newStructure, insertBeforeElement);
            if (debug) {
                log('   ✅ Вставлено перед элементом:', insertBeforeElement.tagName.toLowerCase());
            }
        } else {
            // Если нет элемента для вставки перед, добавляем в конец
            grandParentElement.appendChild(newStructure);
            if (debug) {
                log('   ✅ Добавлено в конец');
            }
        }
        
        if (debug) {
            log('   ✅ Замена завершена');
        }
    }
    
    // ========================================
    // КОНСОЛЬНЫЕ ФУНКЦИИ
    // ========================================
    
    /**
     * Основная функция для полного преобразования с учетом соседних элементов
     * 
     * @param {string} className - Уникальный класс опорного элемента
     * @param {number} threshold - Пороговое значение символов (по умолчанию 500)
     * @param {boolean} verbose - Подробный вывод в консоль (по умолчанию true)
     */
    function runTransformation(className, threshold = 500, verbose = true) {
        log('🚀 Запуск преобразования продукта...');
        log(`📋 Параметры: класс="${className}", порог=${threshold} символов`);
        
        if (verbose) {
            log('='.repeat(50));
        }
        
        try {
            // Проверяем существование элемента
            const referenceElement = findElementByClass(className);
            if (!referenceElement) {
                error(`❌ Элемент с классом "${className}" не найден!`);
                return false;
            }
            
            // Проверяем наличие соседних элементов с классом grid-product
            const parent = referenceElement.parentElement;
            if (parent) {
                const siblings = Array.from(parent.children);
                const currentIndex = siblings.indexOf(referenceElement);
                
                // Проверяем предыдущий элемент
                if (currentIndex > 0) {
                    const prevSibling = siblings[currentIndex - 1];
                    if (prevSibling.classList.contains('grid-product')) {
                        if (verbose) {
                            log(`⏭️  Элемент с классом "${className}" имеет предыдущий сосед с классом grid-product - пропускаем`);
                        }
                        return false;
                    }
                }
                
                // Проверяем следующий элемент
                if (currentIndex < siblings.length - 1) {
                    const nextSibling = siblings[currentIndex + 1];
                    if (nextSibling.classList.contains('grid-product')) {
                        if (verbose) {
                            log(`⏭️  Элемент с классом "${className}" имеет следующий сосед с классом grid-product - пропускаем`);
                        }
                        return false;
                    }
                }
            }
            
            if (verbose) {
                log('✅ Опорный элемент найден:', referenceElement);
            }
            
            // Получаем родительский элемент
            const parentElement = referenceElement.parentElement;
            if (!parentElement) {
                error(`❌ Родительский элемент для "${className}" не найден!`);
                return false;
            }
            
            if (verbose) {
                log('✅ Родительский элемент найден:', parentElement);
            }
            
            // Получаем соседние элементы
            const siblingElements = getSiblingElements(parentElement, referenceElement, verbose);
            if (verbose) {
                log(`📊 Найдено соседних элементов: ${siblingElements.length}`);
                siblingElements.forEach((el, index) => {
                    const textLength = getTextLength(el);
                    log(`   ${index + 1}. ${el.tagName.toLowerCase()}: ${textLength} символов`);
                });
            }
            
            // Отбираем элементы по порогу символов
            const selectedElements = selectElementsByCharacterThreshold(siblingElements, threshold);
            const totalCharacters = selectedElements.reduce((sum, element) => sum + getTextLength(element), 0);
            
            if (verbose) {
                log(`📝 Отобрано элементов: ${selectedElements.length}`);
                log(`📏 Общее количество символов: ${totalCharacters}`);
                log(`🎯 Пороговое значение: ${threshold}`);
                
                if (totalCharacters > threshold) {
                    warn(`⚠️  Количество символов (${totalCharacters}) превышает порог (${threshold})`);
                }
            }
            
            // Преобразуем опорный элемент
            const transformedElement = transformProductCard(referenceElement);
            if (verbose) {
                log('🔄 Опорный элемент преобразован');
            }
            
            // Создаем новую структуру
            const newStructure = createColumnRowStructure(selectedElements, transformedElement);
            if (verbose) {
                log('🏗️  Создана новая структура column-row');
            }
            
            // Заменяем элементы
            replaceElementsWithNewStructure(parentElement, referenceElement, selectedElements, newStructure, verbose);
            
            log('✅ Преобразование завершено успешно!');
            
            if (verbose) {
                log('='.repeat(50));
                log('📋 Итоговая информация:');
                log(`   • Опорный элемент: ${className}`);
                log(`   • Отобрано соседних элементов: ${selectedElements.length}`);
                log(`   • Общее количество символов: ${totalCharacters}`);
                log(`   • Создана структура: column-row product_row`);
            }
            
            return true;
            
        } catch (error) {
            error('❌ Ошибка при выполнении преобразования:', error);
            return false;
        }
    }
    
    /**
     * Функция для быстрого запуска с предустановленными параметрами
     */
    function quickTransform(className) {
        return runTransformation(className, 500, true);
    }
    
    /**
     * Функция для поиска всех элементов с определенным классом и их преобразования
     */
    function transformAllByClass(className, threshold = 500) {
        log(`🔍 Поиск элементов с классом "${className}"...`);
        
        const elements = document.querySelectorAll(`.${className}`);
        log(`📊 Найдено элементов: ${elements.length}`);
        
        if (elements.length === 0) {
            warn(`⚠️  Элементы с классом "${className}" не найдены`);
            return;
        }
        
        let successCount = 0;
        let errorCount = 0;
        
        elements.forEach((element, index) => {
            // Проверяем наличие соседних элементов с классом grid-product
            const parent = element.parentElement;
            if (parent) {
                const siblings = Array.from(parent.children);
                const currentIndex = siblings.indexOf(element);
                
                // Проверяем предыдущий элемент
                if (currentIndex > 0) {
                    const prevSibling = siblings[currentIndex - 1];
                    if (prevSibling.classList.contains('grid-product')) {
                        log(`⏭️  Элемент ${index + 1} имеет предыдущий сосед с классом grid-product - пропускаем`);
                        return; // Пропускаем этот элемент
                    }
                }
                
                // Проверяем следующий элемент
                if (currentIndex < siblings.length - 1) {
                    const nextSibling = siblings[currentIndex + 1];
                    if (nextSibling.classList.contains('grid-product')) {
                        log(`⏭️  Элемент ${index + 1} имеет следующий сосед с классом grid-product - пропускаем`);
                        return; // Пропускаем этот элемент
                    }
                }
            }

            // Создаем уникальный класс для каждого элемента
            const uniqueClass = `${className}-${index}`;
            element.classList.add(uniqueClass);
            
            log(`\n🔄 Обработка элемента ${index + 1}/${elements.length} (класс: ${uniqueClass})`);
            const success = runTransformation(uniqueClass, threshold, false);
            if (success) {
                successCount++;
            } else {
                errorCount++;
            }
        });
        
        log('\n📊 Итоги массового преобразования:');
        log(`   ✅ Успешно: ${successCount}`);
        log(`   ❌ Ошибок: ${errorCount}`);
        log(`   📋 Всего обработано: ${elements.length}`);
    }
    
    /**
     * Функция для отката изменений (удаление созданных структур)
     */
    function rollbackTransformation() {
        log('🔄 Откат преобразований...');
        
        const columnRows = document.querySelectorAll('.column-row.product_row');
        log(`📊 Найдено структур для отката: ${columnRows.length}`);
        
        columnRows.forEach((row, index) => {
            try {
                row.remove();
                log(`✅ Структура ${index + 1} удалена`);
            } catch (error) {
                error(`❌ Ошибка при удалении структуры ${index + 1}:`, error);
            }
        });
        
        log('✅ Откат завершен');
    }
    
    /**
     * Функция для получения статистики по странице
     */
    function getPageStats() {
        log('📊 Статистика страницы:');
        log('='.repeat(40));
        
        // Подсчет различных элементов
        const gridProducts = document.querySelectorAll('.grid-product');
        const productCards = document.querySelectorAll('.product-card');
        const columnRows = document.querySelectorAll('.column-row.product_row');
        
        log(`📦 Grid products: ${gridProducts.length}`);
        log(`🃏 Product cards: ${productCards.length}`);
        log(`🏗️  Column rows: ${columnRows.length}`);
        
        // Поиск элементов с ID
        const elementsWithId = document.querySelectorAll('[id]');
        log(`🏷️  Элементы с ID: ${elementsWithId.length}`);
        
        // Список всех ID
        const ids = Array.from(elementsWithId).map(el => el.id).filter(id => id);
        log(`📋 Список ID:`, ids);
        
        return {
            gridProducts: gridProducts.length,
            productCards: productCards.length,
            columnRows: columnRows.length,
            elementsWithId: elementsWithId.length,
            ids: ids
        };
    }
    
    /**
     * Функция для тестирования функций без изменения DOM
     */
    function testFunctions(className) {
        log('🧪 Тестирование функций...');
        
        const element = findElementByClass(className);
        if (!element) {
            error(`❌ Элемент с классом "${className}" не найден`);
            return;
        }
        
        // Проверяем наличие соседних элементов с классом grid-product
        const parent = element.parentElement;
        if (parent) {
            const siblings = Array.from(parent.children);
            const currentIndex = siblings.indexOf(element);
            
            // Проверяем предыдущий элемент
            if (currentIndex > 0) {
                const prevSibling = siblings[currentIndex - 1];
                if (prevSibling.classList.contains('grid-product')) {
                    log(`⏭️  Элемент с классом "${className}" имеет предыдущий сосед с классом grid-product - пропускаем тестирование`);
                    return;
                }
            }
            
            // Проверяем следующий элемент
            if (currentIndex < siblings.length - 1) {
                const nextSibling = siblings[currentIndex + 1];
                if (nextSibling.classList.contains('grid-product')) {
                    log(`⏭️  Элемент с классом "${className}" имеет следующий сосед с классом grid-product - пропускаем тестирование`);
                    return;
                }
            }
        }
        
        log('🧪 Тестирование функций...');
        
        const siblings = getSiblingElements(parent, element, true); // Включаем дебаг
        const selected = selectElementsByCharacterThreshold(siblings, 500);
        const totalChars = selected.reduce((sum, el) => sum + getTextLength(el), 0);
        
        log('📊 Результаты тестирования:');
        log(`   • Соседних элементов: ${siblings.length}`);
        log(`   • Отобрано элементов: ${selected.length}`);
        log(`   • Общее количество символов: ${totalChars}`);
        log('✅ Тестирование завершено (DOM не изменен)');
    }
    
    /**
     * Функция для детального анализа структуры элемента
     */
    function analyzeElement(className) {
        log('🔍 ДЕТАЛЬНЫЙ АНАЛИЗ ЭЛЕМЕНТА');
        log('='.repeat(50));
        
        const element = findElementByClass(className);
        if (!element) {
            error(`❌ Элемент с классом "${className}" не найден`);
            return;
        }
        
        log('🎯 Опорный элемент:', element);
        log('   Тег:', element.tagName);
        log('   Классы:', element.className);
        log('   ID:', element.id);
        
        // Проверяем наличие соседних элементов с классом grid-product
        const parent = element.parentElement;
        if (parent) {
            const siblings = Array.from(parent.children);
            const currentIndex = siblings.indexOf(element);
            
            log('   Индекс в родителе:', currentIndex);
            
            // Проверяем предыдущий элемент
            if (currentIndex > 0) {
                const prevSibling = siblings[currentIndex - 1];
                const hasPrevGridProduct = prevSibling.classList.contains('grid-product');
                log('   Предыдущий сосед:', `${prevSibling.tagName.toLowerCase()} (${prevSibling.className}) - grid-product: ${hasPrevGridProduct}`);
                
                if (hasPrevGridProduct) {
                    log('⏭️  Элемент имеет предыдущий сосед с классом grid-product - обычно такие элементы пропускаются при преобразовании');
                }
            }
            
            // Проверяем следующий элемент
            if (currentIndex < siblings.length - 1) {
                const nextSibling = siblings[currentIndex + 1];
                const hasNextGridProduct = nextSibling.classList.contains('grid-product');
                log('   Следующий сосед:', `${nextSibling.tagName.toLowerCase()} (${nextSibling.className}) - grid-product: ${hasNextGridProduct}`);
                
                if (hasNextGridProduct) {
                    log('⏭️  Элемент имеет следующий сосед с классом grid-product - обычно такие элементы пропускаются при преобразовании');
                }
            }
        }
        
        if (!parent) {
            error('❌ Родительский элемент не найден');
            return;
        }
        
        log('\n👨‍👩‍👧‍👦 Родительский элемент:', parent);
        log('   Тег:', parent.tagName);
        log('   Классы:', parent.className);
        log('   ID:', parent.id);
        
        const grandParent = parent.parentElement;
        if (!grandParent) {
            error('❌ Родительский элемент родителя не найден');
            return;
        }
        
        log('\n👴 Дедушка (родитель родителя):', grandParent);
        log('   Тег:', grandParent.tagName);
        log('   Классы:', grandParent.className);
        log('   ID:', grandParent.id);
        
        const grandChildren = Array.from(grandParent.children);
        log('\n👶 Всего дочерних элементов у дедушки:', grandChildren.length);
        
        grandChildren.forEach((child, index) => {
            const isParent = child === parent;
            const tagName = child.tagName.toLowerCase();
            const allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'ul', 'ol'];
            const isAllowed = allowedTags.includes(tagName);
            
            log(`   ${index}: ${tagName} (${child.className || 'no-class'}) ${isParent ? '👨‍👩‍👧‍👦 РОДИТЕЛЬ' : ''} ${isAllowed ? '✅' : '❌'}`);
        });
        
        const parentIndex = grandChildren.indexOf(parent);
        log('\n📍 Индекс родительского элемента:', parentIndex);
        
        if (parentIndex !== -1) {
            log('\n🔍 Элементы после родительского элемента:');
            for (let i = parentIndex + 1; i < grandChildren.length; i++) {
                const child = grandChildren[i];
                const tagName = child.tagName.toLowerCase();
                const allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'ul', 'ol'];
                const isAllowed = allowedTags.includes(tagName);
                const textLength = getTextLength(child);
                
                log(`   ${i}: ${tagName} (${child.className || 'no-class'}) - ${textLength} символов ${isAllowed ? '✅' : '❌'}`);
            }
        }
        
        log('\n🧪 Тестирование getSiblingElements с дебагом:');
        const siblings = getSiblingElements(parent, element, true);
        
        log('\n📊 ИТОГОВАЯ СТАТИСТИКА:');
        log(`   • Всего дочерних элементов у дедушки: ${grandChildren.length}`);
        log(`   • Индекс родительского элемента: ${parentIndex}`);
        log(`   • Найдено соседних элементов: ${siblings.length}`);
        log(`   • Общее количество символов в соседних: ${siblings.reduce((sum, el) => sum + getTextLength(el), 0)}`);
    }
    
    /**
     * Функция для простого преобразования элемента по классу
     */
    function transformElementByClass(className) {
        const element = findElementByClass(className);
        if (!element) {
            warn(`❌ Элемент с классом "${className}" не найден`);
            return;
        }
        
        // Проверяем наличие соседних элементов с классом grid-product
        const parent = element.parentElement;
        if (parent) {
            const siblings = Array.from(parent.children);
            const currentIndex = siblings.indexOf(element);
            
            // Проверяем предыдущий элемент
            if (currentIndex > 0) {
                const prevSibling = siblings[currentIndex - 1];
                if (prevSibling.classList.contains('grid-product')) {
                    log(`⏭️  Элемент с классом "${className}" имеет предыдущий сосед с классом grid-product - пропускаем преобразование`);
                    return;
                }
            }
            
            // Проверяем следующий элемент
            if (currentIndex < siblings.length - 1) {
                const nextSibling = siblings[currentIndex + 1];
                if (nextSibling.classList.contains('grid-product')) {
                    log(`⏭️  Элемент с классом "${className}" имеет следующий сосед с классом grid-product - пропускаем преобразование`);
                    return;
                }
            }
        }
        
        const transformedElement = transformProductCard(element);
        if (element.parentNode) {
            element.parentNode.replaceChild(transformedElement, element);
        }
        log(`✅ Элемент с классом ${className} преобразован`);
    }
    
    // ========================================
    // СОЗДАНИЕ SVG ИКОНКИ КОРЗИНЫ
    // ========================================
    
    function createCartIconSVG() {
        // Проверяем, есть ли уже SVG с иконкой корзины
        if (document.getElementById('cart-icon-svg')) {
            return;
        }
        
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.style.display = 'none';
        
        const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        const symbol = document.createElementNS('http://www.w3.org/2000/svg', 'symbol');
        symbol.setAttribute('id', 'cart-icon-svg');
        symbol.setAttribute('viewBox', '0 0 24 24');
        
        const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path1.setAttribute('d', 'M7 4V2C7 1.45 7.45 1 8 1H16C16.55 1 17 1.45 17 2V4H20C20.55 4 21 4.45 21 5S20.55 6 20 6H19V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6H4C3.45 6 3 5.55 3 5S3.45 4 4 4H7ZM9 3V4H15V3H9ZM7 6V19H17V6H7Z');
        
        const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path2.setAttribute('d', 'M9 8V17H11V8H9ZM13 8V17H15V8H13Z');
        
        symbol.appendChild(path1);
        symbol.appendChild(path2);
        defs.appendChild(symbol);
        svg.appendChild(defs);
        
        document.body.appendChild(svg);
        log('✅ SVG иконка корзины создана');
    }
    
    // ========================================
    // ИНИЦИАЛИЗАЦИЯ И ЭКСПОРТ
    // ========================================
    
    var container = document.querySelector('.article__body');
    if (!container) {
        return false;
    }
    log('gooo');
    
    // Создаем SVG иконку корзины
    createCartIconSVG();

    // Проверяем и удаляем первый дочерний элемент с классом grid product-list
    function checkAndRemoveFirstGridProductList() {
        
        // Ищем контейнер с контентом (обычно это body или main)
        const container = document.querySelector('.article__body');
        if (!container) {
            return false;
        }
        
        const firstChild = container.firstElementChild;
        if (!firstChild) {
            return false;
        }
        // Проверяем, есть ли классы grid и product-list
        const hasGridClass = firstChild.classList.contains('grid');
        const hasProductListClass = firstChild.classList.contains('product-list');
        
        
        if (hasGridClass && hasProductListClass) {
            firstChild.remove();
            return true;
        } else {
            return false;
        }
    }
    
    /*
    const allImgs = document.querySelectorAll('img');
    allImgs.forEach(img => {
        if (typeof img.src === 'string') {
            // Проверяем, начинается ли src с нужных доменов
            if (
                img.src.startsWith('https://maxler.com/wp-content/') ||
                img.src.startsWith('https://maxler.de/wp-content/')
            ) {
                // Заменяем префикс на https://wp.maxler
                const newSrc = img.src
                    .replace(/^https:\/\/maxler\.com\//, 'https://wp.maxler.com/')
                    .replace(/^https:\/\/maxler\.de\//, 'https://wp.maxler.de/');
                if (newSrc !== img.src) {
                    img.src = newSrc;
                    log('🔄 Заменен src картинки на:', newSrc);
                }
            }
        }
    });
    //*/

    // Выполняем проверку и удаление
    checkAndRemoveFirstGridProductList();

    transformAllByClass('medium-up--one-half', 600);
    
    // Экспортируем функции в глобальную область видимости
    window.runTransformation = runTransformation;
    window.quickTransform = quickTransform;
    window.transformAllByClass = transformAllByClass;
    window.rollbackTransformation = rollbackTransformation;
    window.getPageStats = getPageStats;
    window.testFunctions = testFunctions;
    window.analyzeElement = analyzeElement;
    window.transformElementByClass = transformElementByClass;
    window.checkAndRemoveFirstGridProductList = checkAndRemoveFirstGridProductList;
    
    // Экспортируем функции логирования
    window.setLogging = setLogging;
    window.isLoggingEnabled = isLoggingEnabled;
    window.log = log;
    window.warn = warn;
    window.error = error;
    
    // Экспортируем вспомогательные функции
    window.findElementByClass = findElementByClass;
    
    // Экспортируем вспомогательные функции
    window.transformProductCard = transformProductCard;
    window.getTextLength = getTextLength;
    window.getSiblingElements = getSiblingElements;
    window.selectElementsByCharacterThreshold = selectElementsByCharacterThreshold;
    window.createColumnRowStructure = createColumnRowStructure;
    window.replaceElementsWithNewStructure = replaceElementsWithNewStructure;
    
    // Выводим справку
    log(`
🚀 УНИВЕРСАЛЬНЫЙ СКРИПТ ПРЕОБРАЗОВАНИЯ ПРОДУКТОВ ЗАГРУЖЕН!
========================================================

📋 Доступные команды:
• runTransformation('class-name', 500) - Полное преобразование
• quickTransform('class-name') - Быстрое преобразование
• transformAllByClass('grid-product') - Массовое преобразование
• rollbackTransformation() - Откат изменений
• getPageStats() - Статистика страницы
• testFunctions('class-name') - Тестирование без изменений
• analyzeElement('class-name') - Детальный анализ структуры
• transformElementByClass('class-name') - Простое преобразование

🔧 Управление логированием:
• setLogging(true/false) - Включить/отключить логирование
• isLoggingEnabled() - Проверить статус логирования
• log('текст') - Вывести сообщение (если логирование включено)
• warn('текст') - Вывести предупреждение (если логирование включено)
• error('текст') - Вывести ошибку (если логирование включено)

📖 Примеры использования:
• getPageStats() - Получить статистику
• analyzeElement('js-transform-start') - Детальный анализ
• testFunctions('js-transform-start') - Протестировать
• runTransformation('js-transform-start', 300) - Преобразовать
• quickTransform('left-product') - Быстрое преобразование
• setLogging(false) - Отключить все логи

🔍 Для отладки проблем используйте:
• analyzeElement('class-name') - Покажет всю структуру и найдет проблему

💡 Совет: Начните с getPageStats() для поиска доступных классов элементов
`);

    log('✅ Все функции готовы к использованию!');
    
}, 200);
